import React from 'react';
import { Box, Typography, IconButton, Badge } from '@mui/material';
import { NotificationsNone as BellIcon } from '@mui/icons-material';

interface DashboardHeaderProps {
    title: string | undefined;
    username: string;
    pharmacyNum: string | null;
    userRole: string | null;
    unreadNotificationsCount?: number;
    onNotificationsClick?: () => void;
    onProfileClick: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
    title,
    pharmacyNum,
    userRole,
    unreadNotificationsCount = 0,
    onNotificationsClick,
    onProfileClick
}) => {
    return (
        <Box sx={{
            height: '48px',
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 4,
            borderBottom: '1px solid #e4e4e7',
            bgcolor: 'white'
        }}>
            <Typography
                variant="h6"
                sx={{
                    color: '#18181b', // zinc-900
                    fontWeight: 600,
                    fontSize: '1.25rem'
                }}
            >
                {title || 'Панель управления'}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                {onNotificationsClick && (
                    <IconButton
                        size="small"
                        onClick={onNotificationsClick}
                        title="Уведомления"
                        sx={{
                            color: unreadNotificationsCount > 0 ? '#ef4444' : '#71717a',
                            '&:hover': { color: '#18181b', bgcolor: '#f4f4f5' }
                        }}
                    >
                        <Badge badgeContent={unreadNotificationsCount} color="error" max={99}>
                            <BellIcon sx={{ fontSize: 20 }} />
                        </Badge>
                    </IconButton>
                )}

                <div style={{ width: '1px', height: '16px', backgroundColor: '#e4e4e7' }}></div>

                <Typography
                    onClick={onProfileClick}
                    sx={{
                        fontSize: '0.875rem',
                        color: '#71717a', // zinc-500
                        cursor: 'pointer',
                        transition: 'color 0.2s',
                        '&:hover': {
                            color: '#18181b' // zinc-900
                        }
                    }}
                >
                    Профиль
                </Typography>
                <div style={{ width: '1px', height: '16px', backgroundColor: '#e4e4e7' }}></div>
                <Typography
                    sx={{
                        fontSize: '0.875rem',
                        fontWeight: 500,
                        color: '#18181b'
                    }}
                >
                    {pharmacyNum
                        ? (userRole === 'storage' ? `Склад ${pharmacyNum}` : `Аптека №${pharmacyNum}`)
                        : 'Загрузка...'}
                </Typography>
            </Box>
        </Box>
    );
};

export default DashboardHeader;
